import { useQuery } from '@tanstack/react-query';

import { hookEnabledError } from '@hcs/utils';

import { OrgUsersApi } from '../api';

export const QUERY_KEY_ORG_USERS = 'org-users';

export const useOrgUsers = (orgId: number | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEY_ORG_USERS, orgId],

    queryFn: async () => {
      if (orgId) {
        return await OrgUsersApi.getOrgUsers(orgId);
      } else {
        throw hookEnabledError('useOrgUsers', 'orgId');
      }
    },

    enabled: !!orgId,
  });
};
